<template>
    <div class="has-background-heat-blue-1">
        <section class="section has-text-centered no-bottom-padding-mobile">
            <br>
            <figure class="image is-fancy">
                <img :src="HeatLogo" alt="HEAT Logo">
            </figure>
            <div class="hero">
                <div class="hero-body">
                    <h1 class="title is-large has-text-white">HEAT LIVE VIEW</h1>
                </div>
            </div>
            <div class="box is-fancy" :class="{'full-width-inside-section': !isTablet}">
                <div class="hero">
                    <div class="hero-head">
                        <h1 v-if="isLoggedIn" class="title is-large has-text-grey">Click To View EDAR</h1>
                    </div>
                </div>
                <div class="hero-body is-flex" style="align-items: center; justify-content: center; flex-wrap: wrap">
                    <div v-if="!isLoggedIn">
                        <login style="margin: auto;" :horizontal="true"></login>
                        <br>
                        <a @click="showPasswordReset = true" class="href">Click here if you forgot your password.</a>
                        <password-reset-modal :active.sync="showPasswordReset" :resetUrl="urls.password_reset"></password-reset-modal>
                    </div>
                    <div v-else v-for="(edar, index) in edars" v-bind:key="index" class="edar_selector">
                        <router-link v-if="edar.online" :to="{name: 'viewer', params: {edarId: edar.id}}">
                            <img class="image is-small" :src="EdarLogo" alt="EDAR Logo" >
                            <h1 class="title heat-edar-logo-blue">{{edar.name}}</h1>
                        </router-link>
                        <div v-else class="is-unselectable" style="opacity: 0.3;">
                            <img class="image is-small" :src="EdarLogo" alt="EDAR Logo" >
                            <h1 class="title heat-edar-logo-blue">{{edar.name}}</h1>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <router-link :to="{name: 'main-site'}" class="has-text-grey-light">Interested in HEAT or EDAR? Click here to check us out.</router-link>
        </section>
    </div>
</template>

<script>
    import HeatLogo from "heat-shared/static/HEAT Logo for Box - Transparent.png";
    import EdarLogo from "heat-shared/static/Blue EDAR Logo Only.png";
    import {mapGetters, mapState} from "vuex";
    import Login from "../components/Login";
    import {isSize} from "../mixins"
    import urls from "../urls"
    import PasswordResetModal from "heat-shared/src/components/PasswordResetModal";

    export default {
        name: "HomePage",
        mixins: [isSize, urls],
        components: {PasswordResetModal, Login},
        data: () => ({
            'showPasswordReset': false,
        }),
        computed: {
            ...mapGetters('user', [
                'isLoggedIn',
            ]),
            ...mapState('edar', [
                'edars',
            ]),
            HeatLogo: ()=> HeatLogo,
            EdarLogo: ()=> EdarLogo,
        },
        mounted() {
            if (this.isLoggedIn) {
                this.$store.dispatch('edar/getEdars');
            }
        },
        watch: {
            //Get a list of edars when a user logs in
            isLoggedIn(value) {
                if(value) {
                    this.$store.dispatch('edar/getEdars')
                }
            }
        },
    }
</script>

<style scoped>
    .edar_selector {
        max-width: 35ch;
        min-width: 35ch;
        padding: 1ch;
    }
</style>